module.exports = __webpack_public_path__ + "media/images/store_btn_ov-37e9e358dea74b996050334a211f3709.gif";